import React from 'react';
import cn from 'classnames';

const Indicator = ({ indicatorPlacement, componentIndex }) => {
  setTimeout(() => {
    document.getElementsByClassName(
      `Indicator-containerWithMarker ${componentIndex}`,
    )[0].style.left = `${indicatorPlacement}%`;
  }, 200);

  return (
    <div
      className={cn(
        `Indicator Indicator-containerWithMarker ${componentIndex}`,
      )}
    >
      <div className="Indicator-marker" />
    </div>
  );
};

export default Indicator;
